module.exports = __webpack_public_path__ + "static/media/desserts.977df5b8.png";